import * as Yup from "yup";

export const datesForDairiesSchema = Yup.object().shape({
  title: Yup.string().required("Please enter a Title"),
  description: Yup.string().required("Please enter a Description"),
  category: Yup.string().required("Please enter a Category"),
  info: Yup.string().required("Please Enter the Info"),
  startDate: Yup.string()
  .required("Please Enter Start Date")
  .test(
    "is-future-date",
    "Start date and time must be in the future",
    (value) => {
      return value && new Date(value) > new Date();
    }
  ),

endDate: Yup.string()
  .required("Please Enter End Date")
  .test(
    "is-after-start",
    "End date cannot be before start date",
    function (value) {
      const { startDate } = this.parent;
      return value && startDate && new Date(value) > new Date(startDate);
    }
  ),
});
